import { render, staticRenderFns } from "./Certificateinfo.vue?vue&type=template&id=35d1a95c&scoped=true&"
import script from "./Certificateinfo.vue?vue&type=script&lang=js&"
export * from "./Certificateinfo.vue?vue&type=script&lang=js&"
import style0 from "./Certificateinfo.vue?vue&type=style&index=0&id=35d1a95c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1a95c",
  null
  
)

export default component.exports